/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { ArrowLeftIcon, NoPhotoIcon } from 'shared/components/Icons';
import Slider from 'react-slick';
import { BlockInfo } from './ProductImageBlock';
import { useTranslation } from 'react-i18next';

const ProductImageSlider = ({ images, mainImage, className = '', options = {}, slideMaxCount }) => {
  const { t } = useTranslation();
  const slider = useRef();
  const sliderWrapper = useRef();
  const [current, setCurrent] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});

  const onImageLoaded = i => {
    setLoadedImages(state => ({ ...state, [i]: 1 }));
  };

  const onImageError = i => {
    setLoadedImages(state => ({ ...state, [i]: 0 }));
  };

  const settings = {
    arrows: false,
    adaptiveHeight: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => setCurrent(next),
    ...options,
  };

  const stopPropagation = e => {
    e.stopPropagation();
  };

  const handleChange = (next, e) => {
    e.stopPropagation();
    if (next) {
      slider.current.slickNext();
    } else {
      slider.current.slickPrev();
    }
  };

  const correctSlickDots = () => {
    const dots = sliderWrapper.current.querySelector('.slick-dots');
    if (!dots) return;
    dots.style.marginLeft = `${-dots.clientWidth / 2}px`;
  };

  useEffect(() => {
    correctSlickDots();
  }, []);

  const slideImages = slideMaxCount ? [...images].splice(0, slideMaxCount) : [...images];

  return (
    <div className={`product-slider ${className}`} ref={sliderWrapper}>
      <Slider {...settings} ref={slider}>
        {slideImages.map((item, i) => {
          const isLoading = loadedImages[i] === undefined;
          const isLoaded = loadedImages[i] === 1;
          const isError = loadedImages[i] === 0;
          return (
            <React.Fragment key={i}>
              <img
                src={item}
                alt='slide'
                className={isLoaded ? 'd-block' : 'd-none'}
                onLoad={onImageLoaded.bind(null, i)}
                onError={onImageError.bind(null, i)}
              />
              {isLoading && (
                <BlockInfo
                  descClassName='text-black-50'
                  className='no-photo justify-content-center'
                  description={t('text_loading')}
                  icon={<NoPhotoIcon />}
                />
              )}
              {isError && !mainImage && (
                <BlockInfo
                  descClassName='text-black-50'
                  className='no-photo justify-content-center'
                  description={t('text_no_photo')}
                  icon={<NoPhotoIcon />}
                />
              )}
              {isError && mainImage && <img src={mainImage} alt='rimg' className='d-block' />}
            </React.Fragment>
          );
        })}
      </Slider>
      {slideImages.length > 1 && (
        <div className='slick-arrows d-none d-md-flex' onClick={stopPropagation}>
          <button className='btn p-0 btn-prev' disabled={current === 0} onClick={handleChange.bind(null, false)}>
            <ArrowLeftIcon />
          </button>
          <button
            className='btn p-0 ml-6 btn-next'
            disabled={current === slideImages.length - 1}
            onClick={handleChange.bind(null, true)}
          >
            <ArrowLeftIcon />
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductImageSlider;
